/**
 * 销退订单枚举
 */

// 是否(0-是，1-否)
export enum ZeroIsYesEnum {
  YES = 0,
  NO = 1,
}
export enum ZeroIsYesEnumName {
  YES = '是',
  NO = '否',
}

// 订单类型1.销售，2.销售退货
export enum OrderTypeEnum {
  /**
   * 销售
   */
  SALE = 1,
  /**
   * 销售退货
   */
  SALE_RETURN = 2,
}
export enum OrderTypeEnumName {
  SALE = '销售',
  SALE_RETURN = '销售退货',
}

// 贸易类型（1.国内贸易、2.跨境贸易）
export enum TradeTypeEnum {
  /**
   * 国内贸易
   */
  DOMESTIC_TRADE = 1,
  /**
   * 跨境贸易
   */
  CROSS_BORDER_TRADE = 2,
}
export enum TradeTypeEnumName {
  DOMESTIC_TRADE = '国内贸易',
  CROSS_BORDER_TRADE = '跨境贸易',
}

// 发货类型 1.自发，2.省店代发，3.供应商代发
export enum ShippingTypeEnum {
  /**
   * 自发
   */
  SELF_DELIVERY = 1,
  /**
   * 省店代发
   */
  PROVINCE_DELIVERY = 2,
  /**
   * 供应商代发
   */
  SUPPLIER_DELIVERY = 3,
}
export enum ShippingTypeEnumName {
  SELF_DELIVERY = '自发',
  PROVINCE_DELIVERY = '省店代发',
  SUPPLIER_DELIVERY = '供应商代发',
}

// 业务属性 (一级：1教材、2电商、3阅读、4馆配、5创新)
export enum BizAttrTypeEnum {
  // /**
  //  * 教材
  //  */
  // TEXTBOOK = 1,
  // /**
  //  * 电商
  //  */
  // E_COMMERCE = 2,
  /**
   * 阅读
   */
  READING = 3,
  /**
   * 馆配
   */
  LIBRARY = 4,
  /**
   * 创新
   */
  INNOVATION = 5,
}
export enum BizAttrTypeEnumName {
  TEXTBOOK = '教材',
  E_COMMERCE = '电商',
  READING = '阅读',
  LIBRARY = '馆配',
  INNOVATION = '创新',
}

// 业务属性-教材（二级：1中小学、2大中专、3教辅、4幼儿）
export enum BizAttrTypeSubEnum {
  /**
   * 中小学
   */
  PRIMARY_SCHOOL = 1,
  /**
   * 大中专
   */
  HIGH_SCHOOL = 2,
  /**
   * 教辅
   */
  AUXILIARY = 3,
  /**
   * 幼儿
   */
  KINDERGARTEN = 4,
}
export enum BizAttrTypeSubEnumName {
  PRIMARY_SCHOOL = '中小学',
  HIGH_SCHOOL = '大中专',
  AUXILIARY = '教辅',
  KINDERGARTEN = '幼儿',
}

//  订单状态（1.草稿或新建-b/初始化失败-c)、2.待审核、3.已驳回（审核失败）、4.已审核、5.已取消、6.已关闭)
export enum OrderStatusEnum {
  /**
   * 草稿或新建-b/初始化失败-c
   */
  DRAFT_OR_NEW = 1,
  /**
   * 待审核
   */
  PENDING_APPROVAL = 2,
  /**
   * 已驳回（审核失败）
   */
  REJECTED = 3,
  /**
   * 已审核
   */
  APPROVED = 4,
  /**
   * 已取消
   */
  CANCELLED = 5,
  /**
   * 已关闭
   */
  CLOSED = 6,
}
export enum OrderStatusEnumName {
  DRAFT_OR_NEW = '草稿',
  PENDING_APPROVAL = '待审核',
  REJECTED = '已驳回',
  APPROVED = '已审核',
  CANCELLED = '已取消',
  CLOSED = '已关闭',
}
/**
 * 订单状态-tags颜色
 */
export enum OrderStatusEnumColor {
  DRAFT_OR_NEW = 'blue',
  PENDING_APPROVAL = 'green',
  REJECTED = 'red',
  APPROVED = 'orange',
  CANCELLED = 'purple',
  CLOSED = 'cyan',
}

// 业务模式 （1-批发 2-团购，3零售）
export enum BusinessModeEnum {
  /**
   * 批发
   */
  WHOLESALE = 1,
  /**
   * 团购
   */
  GROUP_BUYING = 2,
  /**
   * 零售
   */
  RETAIL = 3,
}
export enum BusinessModeEnumName {
  WHOLESALE = '批发',
  GROUP_BUYING = '团购',
  RETAIL = '零售',
}


// 订单来源 (1.ERP 2.芸台购 3.钱塘鸿书 4.pos 5.渠道各种电商平台)
export enum OrderSourceEnum {
  /**
   * ERP
   */
  ERP = 1,
  /**
   * 芸台购
   */
  YTG = 2,
  /**
   * 钱塘鸿书
   */
  QIAN_TANG_HONG_SHU = 3,
  /**
   * POS
   */
  POS = 4,
  /**
   * 渠道各种电商平台
   */
  CHANNEL_ECOMMERCE_PLATFORMS = 5,
}
export enum OrderSourceEnumName {
  ERP = 'ERP',
  YTG = '芸台购',
  QIAN_TANG_HONG_SHU = '钱塘鸿书',
  POS = 'POS',
  CHANNEL_ECOMMERCE_PLATFORMS = '渠道各种电商平台',
}

// 商品业务类型（分为1.常规、2.卡券（充值卡&提货券）)
export enum ProductBizTypeEnum {
  /**
   * 常规
   */
  REGULAR = 1,
  /**
   * 卡券（充值卡&提货券）
   */
  COUPON = 2,
}
export enum ProductBizTypeEnumName {
  REGULAR = '常规',
  COUPON = '卡券（充值卡&提货券）',
}


// 退货原因（1.常规退货、2.超数量退货、3.业务拒收退货、4.不成套退货，5.破损退货、6.污损退货，7.少附件退货）
export enum ReturnReasonEnum {
  /**
   * 常规退货
   */
  REGULAR_RETURN = 1,
  /**
   * 超数量退货
   */
  EXCESS_RETURN = 2,
  /**
   * 业务拒收退货
   */
  BUSINESS_REJECTION_RETURN = 3,
  /**
   * 不成套退货
   */
  INCOMPLETE_SET_RETURN = 4,
  /**
   * 破损退货
   */
  BROKEN_RETURN = 5,
  /**
   * 污损退货
   */
  DAMAGED_RETURN = 6,
  /**
   * 少附件退货
   */
  MISSING_ATTACHMENT_RETURN = 7,
}
export enum ReturnReasonEnumName {
  REGULAR_RETURN = '常规退货',
  EXCESS_RETURN = '超数量退货',
  BUSINESS_REJECTION_RETURN = '业务拒收退货',
  INCOMPLETE_SET_RETURN = '不成套退货',
  BROKEN_RETURN = '破损退货',
  DAMAGED_RETURN = '污损退货',
  MISSING_ATTACHMENT_RETURN = '少附件退货',
}

// 履约状态(1.未开始、2.无需履约、3.待通知、4.部分通知、5.已通知、6.部分发货、7.已发货、8.部分收货、9.已收货、10.已完成、11.已终止)
export enum FulfillStatusEnum {
  /**
   * 未开始
   */
  NOT_STARTED = 1,
  /**
   * 无需履约
   */
  NO_NEED_TO_FULFILL = 2,
  /**
   * 待通知
   */
  PENDING_NOTIFICATION = 3,
  /**
   * 部分通知
   */
  PARTIAL_NOTIFICATION = 4,
  /**
   * 已通知
   */
  NOTIFIED = 5,
  /**
   * 部分发货
   */
  PARTIAL_SHIPMENT = 6,
  /**
   * 已发货
   */
  SHIPPED = 7,
  /**
   * 部分收货
   */
  PARTIAL_RECEIPT = 8,
  /**
   * 已收货
   */
  RECEIVED = 9,
  /**
   * 已完成
   */
  COMPLETED = 10,
  /**
   * 已终止
   */
  TERMINATED = 11,
}
export enum FulfillStatusEnumName {
  NOT_STARTED = '未开始',
  NO_NEED_TO_FULFILL = '无需履约',
  PENDING_NOTIFICATION = '待通知',
  PARTIAL_NOTIFICATION = '部分通知',
  NOTIFIED = '已通知',
  PARTIAL_SHIPMENT = '部分发货',
  SHIPPED = '已发货',
  PARTIAL_RECEIPT = '部分收货',
  RECEIVED = '已收货',
  COMPLETED = '已完成',
  TERMINATED = '已终止',
}

// 结算方式（1.赊账、2.现结 ，3.内部结算）
export enum SettleModeEnum {
  /**
   * 赊账
   */
  CREDIT = 1,
  /**
   * 现结
   */
  CASH = 2,
  /**
   * 内部结算
   */
  INTERNAL_SETTLEMENT = 3,
}
export enum SettleModeEnumName {
  CREDIT = '赊账',
  CASH = '现结',
  INTERNAL_SETTLEMENT = '内部结算',
}

// 支付状态(1-待支付、2-部分支付、3-已支付)
export enum PayStatusEnum {
  /**
   * 待支付
   */
  PENDING_PAYMENT = 1,
  /**
   * 部分支付
   */
  PARTIAL_PAYMENT = 2,
  /**
   * 已支付
   */
  PAID = 3,
}
export enum PayStatusEnumName {
  PENDING_PAYMENT = '待支付',
  PARTIAL_PAYMENT = '部分支付',
  PAID = '已支付',
}

// 物流信息配送方式: (1-快运、2-快递、3-自配送、4-自提)
export enum DeliveryMethodEnum {
  /**
   * 快运
   */
  CLY = 1,
  /**
   * 快递
   */
  EXPRESS = 2,
  /**
   * 自配送
   */
  SELF_DELIVERY = 3,
  /**
   * 自提
   */
  SELF_PICKUP = 4,
}
export enum DeliveryMethodEnumName {
  CLY = '快运',
  EXPRESS = '快递',
  SELF_DELIVERY = '自配送',
  SELF_PICKUP = '自提',
}

// 业务线类型: 1-中小学、2-大中专、3-批发团购、4-零售
export enum BusinessTypeEnum {
  /**
   * 中小学
   */
  PRIMARY_SCHOOL = 1,
  /**
   * 大中专
   */
  HIGH_SCHOOL = 2,
  /**
   * 批发团购
   */
  WHOLESALE_GROUP_BUYING = 3,
  /**
   * 零售
   */
  RETAIL = 4,
}
export enum BusinessTypeEnumName {
  PRIMARY_SCHOOL = '中小学',
  HIGH_SCHOOL = '大中专',
  WHOLESALE_GROUP_BUYING = '批发团购',
  RETAIL = '零售',
}

// 组合标识(1-实物父项、2-实物子项、3-虚拟父项、4-虚拟子项)
export enum AssemblyEnum {
  /**
   * 实物父项
   */
  PHYSICAL_PARENT = 1,
  /**
   * 实物子项
   */
  PHYSICAL_CHILD = 2,
  /**
   * 虚拟父项
   */
  VIRTUAL_PARENT = 3,
  /**
   * 虚拟子项
   */
  VIRTUAL_CHILD = 4,
}
export enum AssemblyEnumName {
  PHYSICAL_PARENT = '实物父项',
  PHYSICAL_CHILD = '实物子项',
  VIRTUAL_PARENT = '虚拟父项',
  VIRTUAL_CHILD = '虚拟子项',
}



//店类型：0-省店，1-基层店
export enum StoreTypeEnum {
  /**
   * 省店
   */
  PROVINCE_STORE = 0,
  /**
   * 基层店
   */
  BASE_STORE = 1,
}
export enum StoreTypeEnumName {
  PROVINCE_STORE = '省店',
  BASE_STORE = '基层店',
}

// 财务信息-结算币种符号 b端 c端
export enum PaymentCurrencySymbolEnum {
  /**
   * b端
   */
  B = 'b',
  /**
   * c端
   */
  C = 'c',
}
export enum PaymentCurrencySymbolEnumName {
  B = 'b端',
  C = 'c端',
}

// 订单来源单据类型  1-人工新增订单 2-采购单 3-主配单 4-售后申请单  5-渠道原始订单
export enum OrderSourceTypeEnum {
  /**
   * 人工新增订单
   */
  MANUAL_ADDITION_ORDER = 1,
  /**
   * 采购单
   */
  PURCHASE_ORDER = 2,
  /**
   * 主配单
   */
  MASTER_ORDER = 3,
  /**
   * 售后申请单
   */
  AFTER_SALES_APPLICATION_ORDER = 4,
  /**
   * 渠道原始订单
   */
  CHANNEL_RAW_ORDER = 5,
}
export enum OrderSourceTypeEnumName {
  MANUAL_ADDITION_ORDER = '人工新增订单',
  PURCHASE_ORDER = '采购单',
  MASTER_ORDER = '主配单',
  AFTER_SALES_APPLICATION_ORDER = '售后申请单',
  CHANNEL_RAW_ORDER = '渠道原始订单',
}

// 放单规则(1-整单一次性满足放单、2-单品满足放单、3-单品部分满足部分放单) b端 c端
export enum OrderReleaseRuleEnum {
  /**
   * 整单一次性满足放单
   */
  WHOLE_ORDER_ONCE = 1,
  /**
   * 单品满足放单
   */
  SINGLE_ITEM_FULFILLMENT = 2,
  /**
   * 单品部分满足部分放单
   */
  PARTIAL_FULFILLMENT = 3,
}
export enum OrderReleaseRuleEnumName {
  WHOLE_ORDER_ONCE = '整单一次性满足放单',
  SINGLE_ITEM_FULFILLMENT = '单品满足放单',
  PARTIAL_FULFILLMENT = '单品部分满足部分放单',
}

// 订单标识 1-普通订单 2-急件订单 3-直发订单 4-一件代发 5-按需发货 6-按单发货  7-自提订单
export enum OrderIdentifierEnum {
  /**
   * 普通订单
   */
  NORMAL_ORDER = 1,
  /**
   * 急件订单
   */
  EXPRESS_ORDER = 2,
  /**
   * 直发订单
   */
  DIRECT_DELIVERY_ORDER = 3,
  /**
   * 一件代发
   */
  ONE_PIECE_DELIVERY = 4,
  /**
   * 按需发货
   */
  ON_DEMAND_DELIVERY = 5,
  /**
   * 按单发货
   */
  ORDER_DELIVERY = 6,
  /**
   * 自提订单
   */
  SELF_PICKUP_ORDER = 7,
}
export enum OrderIdentifierEnumName {
  NORMAL_ORDER = '普通订单',
  EXPRESS_ORDER = '急件订单',
  DIRECT_DELIVERY_ORDER = '直发订单',
  ONE_PIECE_DELIVERY = '一件代发',
  ON_DEMAND_DELIVERY = '按需发货',
  ORDER_DELIVERY = '按单发货',
  SELF_PICKUP_ORDER = '自提订单',
}

// 订单业务类型（1.常规、2.换货、3.补发） b端 c端
export enum OrderBizTypeEnum {
  /**
   * 常规
   */
  REGULAR = 1,
  /**
   * 换货
   */
  EXCHANGE = 2,
  /**
   * 补发
   */
  REISSUE = 3,
}
export enum OrderBizTypeEnumName {
  REGULAR = '常规',
  EXCHANGE = '换货',
  REISSUE = '补发',
}

// 订单商业类型 B,C
export enum IndustryTypeEnum {
  /**
   * B
   */
  B = 'B',
  /**
   * C
   */
  C = 'C',
}
export enum IndustryTypeEnumName {
  B = 'B',
  C = 'C',
}

// 拆合标识（0.拆，1合） c端
export enum DisassemblyIdentifierEnum {
  /**
   * 拆
   */
  DISASSEMBLY = 0,
  /**
   * 合
   */
  ASSEMBLY = 1,
}
export enum DisassemblyIdentifierEnumName {
  DISASSEMBLY = '拆',
  ASSEMBLY = '合',
}

// 配送方式 （1-自提，2-快递或快运，3-自配送，4-即时配送，5-闪送） b端 c端
export enum DeliveryTypeEnum {
  /**
   * 自提
   */
  SELF_PICKUP = 1,
  /**
   * 快递或快运
   */
  EXPRESS_OR_CARRIAGE = 2,
  /**
   * 自配送
   */
  SELF_DELIVERY = 3,
  /**
   * 即时配送
   */
  INSTANT_DELIVERY = 4,
  /**
   * 闪送
   */
  FLASH_DELIVERY = 5,
}
export enum DeliveryTypeEnumName {
  SELF_PICKUP = '自提',
  EXPRESS_OR_CARRIAGE = '快递或快运',
  SELF_DELIVERY = '自配送',
  INSTANT_DELIVERY = '即时配送',
  FLASH_DELIVERY = '闪送',
}

// 客户类型 （1.内部客户，2外部客户 3.没有法人的团体） b端
export enum CustomerTypeEnum {
  /**
   * 内部客户
   */
  INTERNAL_CUSTOMER = 1,
  /**
   * 外部客户
   */
  EXTERNAL_CUSTOMER = 2,
  /**
   * 没有法人的团体
   */
  GROUP_WITHOUT_LEGAL_ENTITY = 3,
}
export enum CustomerTypeEnumName {
  INTERNAL_CUSTOMER = '内部客户',
  EXTERNAL_CUSTOMER = '外部客户',
  GROUP_WITHOUT_LEGAL_ENTITY = '没有法人的团体',
}

// 地址类型（1.自提地址  2. 收货地址  3. 退件发货地址 4. 报订单位地址  5.客户流向地址）     b端 c端
export enum CustomerAddressTypeEnum {
  /**
   * 自提地址
   */
  SELF_PICKUP_ADDRESS = 1,
  /**
   * 收货地址
   */
  RECEIVING_ADDRESS = 2,
  /**
   * 退件发货地址
   */
  RETURN_DELIVERY_ADDRESS = 3,
  /**
   * 报订单位地址
   */
  ORDERING_UNIT_ADDRESS = 4,
  /**
   * 客户流向地址
   */
  CUSTOMER_FLOW_ADDRESS = 5,
}
export enum CustomerAddressTypeEnumName {
  SELF_PICKUP_ADDRESS = '自提地址',
  RECEIVING_ADDRESS = '收货地址',
  RETURN_DELIVERY_ADDRESS = '退件发货地址',
  ORDERING_UNIT_ADDRESS = '报订单位地址',
  CUSTOMER_FLOW_ADDRESS = '客户流向地址',
}

//  结算方式（1.赊账、2.现结 ，3.内部结算）
export enum SettlementTypeEnum {
  /**
   * 赊账
   */
  CREDIT = 1,
  /**
   * 现结
   */
  CASH = 2,
  /**
   * 内部结算
   */
  INTERNAL_SETTLEMENT = 3,
}
export enum SettlementTypeEnumName {
  CREDIT = '赊账',
  CASH = '现结',
  INTERNAL_SETTLEMENT = '内部结算',
}
